/**
 * @description Wanna IFrame implementation
 * @param AccessibilityFocusTrapMixin AccessibilityFocusTrapMixin widget for extending
 * @returns Wanna IFrame widget
 */

function WannaARIFrameClassCreator(AccessibilityFocusTrapMixin: import('widgets/global/AccessibilityFocusTrapMixin').TAccessibilityFocusTrapMixin) {
    class WannaARIFrame extends AccessibilityFocusTrapMixin {
        prefs() {
            return {
                iframeUrl: '',
                modalUrl: '',
                ...super.prefs()
            };
        }

        private focusOnCloseButton(): void {
            const parentNode = this.ref('self').get()?.closest('.b-dialog.m-wanna');

            parentNode?.querySelector<HTMLButtonElement>('.b-drawer-close')?.focus();
        }

        init(): void {
            super.init();
            this.eventBus().on('wannaiframe.show', 'showIFrame');
            this.focusOnCloseButton();
        }

        /**
         * @description Brings Wanna IFrame into viewport
         */
        showIFrame(): void {
            this.show();
            this.ref('iframe').attr('src', this.prefs().iframeUrl); // reinit iframe src
            this.focusOnCloseButton();
        }

        /**
         * @description Removes Wanna IFrame from viewport
         */
        hideIFrame(): void {
            this.hide();
            this.ref('iframe').attr('src', ''); // removes iframe src to disable iframe and disable camera usage
        }
    }

    return WannaARIFrame;
}

export type TWannaARIFrame = ReturnType<typeof WannaARIFrameClassCreator>;

export type TWannaARIFrameInstance = InstanceType<TWannaARIFrame>;

export default WannaARIFrameClassCreator;
